import { useContext, useEffect, useState } from 'react';
import Conversation from 'components/ai-chat-board/Conversation';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    useNavigate,
    useParams,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import StateContext from 'constants/StateContext';


interface StateContextType {
    setParamsId: React.Dispatch<React.SetStateAction<string>>;
    handleNewChatButton: () => void;
    handleGetConversation: (id: string, username: string | null) => void;
    setHover: React.Dispatch<React.SetStateAction<string | null>>
}

function AiChatbot() {
    const { setParamsId, handleNewChatButton, handleGetConversation, setHover } = useContext<StateContextType>(StateContext);
    //variables
    const navigate = useNavigate();
    const hisoryCalled = useSelector((state: any) => state.counter.hisoryCalled);
    const params = useParams();
    const [pressed, setPressed] = useState<boolean>(false);
    const qMateCounter = useSelector((state: any) => state.counter.qMateCounter);
    if (!params || !params.id || params.id === 'undefined') {
        navigate(`/chat-bot/new-chat`);
    }


    useEffect(() => {
        if (qMateCounter) {
            handleNewChatButton();
        }
    }, [qMateCounter])

    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.setItem("reloaded", "true");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        window.onpopstate = e => {
            setPressed(true);
        };
    });

    const tempFunc = () => {
        if (params.id) {
            handleGetConversation(params.id, localStorage.getItem('username'));
        }
        setPressed(false);
    }
    useEffect(() => {
        if (params.id !== 'new-chat' && params.id !== undefined && hisoryCalled) {
            // setHover(null);
            tempFunc();
        }
    }, [params.id])

    useEffect(() => {
        const handleBackButton = () => {
            setHover(null); // Reset state when the back button is clicked
        };

        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
        };
    }, []);

    

    const notify = (toastmsg: any) => {
        return toast(toastmsg, {
            position: 'bottom-center',
            style: {
                backgroundColor: '#F1F1F1', // Grey background
            }

        });
    };
    useEffect(() => {
        if (params.id) {
            setParamsId(params.id)
        }
    }, [params])


    return (
        <>
            <main className="content-wrapper" >
                <Conversation
                    notify={notify}
                    component={'qmate'}
                />
            </main>
        </>
    );
}

export default AiChatbot;
